import React, { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import DefaultLayout from "layout/defaultLayout";
import PageTitles from "../../components/PageTitles";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAccount } from "../../store/slices/account/accountSlice";

const TransitionPage = () => {
    const {accounts, account, accountsStatus} = useSelector(state => state?.account)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (accounts.length === 0) return;

        // Only reuse the stored account when it is still part of the user's
        // list, otherwise we would send them back to a `/home/:idaccount` the
        // account guard rejects, bouncing them here again.
        const storedAccount = accounts.find(
            (item) => String(item?.account_id) === String(account?.account_id)
        );

        if (storedAccount) {
            navigate(`/home/${storedAccount.account_id}`);
            return;
        }

        const favoriteAccount =
            accounts.find((item) => item?.['is_favorite']) ||
            accounts[accounts.length - 1];
        dispatch(updateAccount(favoriteAccount));
        navigate(`/home/${favoriteAccount.account_id}`);
    }, [accounts, navigate, dispatch, account]);

    const isLoadingAccounts =
        accounts.length === 0 &&
        (accountsStatus === "idle" || accountsStatus === "loading");

    return (
        // With no account there is nothing the product sidebar can open, so it
        // stays hidden until an account is resolved (at which point the effect
        // above has already sent the user to the dashboard).
        <DefaultLayout hideSidebar={accounts.length === 0}>
            {accounts.length > 0 && (
                <Box sx={{ display: "flex", justifyContent: "space-between", marginRight: "18px" }}>
                    <PageTitles pageTitle="Digital Marketing Platform" />
                </Box>
            )}

            {isLoadingAccounts && (
                <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                    <CircularProgress size={24} />
                </Box>
            )}

            {accounts.length === 0 && accountsStatus === "failed" && (
                <Typography sx={{ mt: 4, textAlign: "center" }}>
                    We could not load your accounts. Please refresh the page or contact support.
                </Typography>
            )}

            {accounts.length === 0 && accountsStatus === "succeeded" && (
                <Typography sx={{ mt: 4, textAlign: "center" }}>
                    No account available, please contact support.
                </Typography>
            )}

            {accounts.length > 0 && (
                <Typography sx={{ mt: 4, textAlign: "center" }}>
                    Accounts Loaded Successfully
                </Typography>
            )}
        </DefaultLayout>
    );
};

export default TransitionPage;
